export const BAZAAR_STATUS_COLORS = {
  Pending: 'gold',
  Accepted: 'blue',
  Fulfilled: 'cyan',
  InProgress: 'green',
  Completed: 'default',
  Cancelled: 'red',
  Rejected: 'red',
};

export const BAZAAR_STATUS_LABELS = {
  Pending: 'Pending approval',
  Accepted: 'Accepted',
  Fulfilled: 'Stock sent',
  InProgress: 'In progress',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  Rejected: 'Rejected',
};

export const BAZAAR_STATUSES = Object.keys(BAZAAR_STATUS_LABELS);

export const bazaarStatusLabel = (status) => BAZAAR_STATUS_LABELS[status] || status;

export const bazaarModeLabel = (mode) => (mode === 'POS' ? 'Chainz POS' : 'Outbound only');
